<app-floating-panel
  [title]="title"
  minimizedIcon="pan_tool"
  storageKey="whiteboard-panel"
  [initialWidthPercent]="0.8"
  [initialHeightPercent]="0.8"
  [minWidth]="280"
  [minHeight]="200"
  [showMaximize]="true"
  [showMinimize]="true"
  (closed)="onPanelClose()"
  (initialized)="onPanelInitialized()"
>
  <app-whiteboard
    [canvasData]="canvasData"
    [closedExternally]="closedExternally"
    (close)="onWhiteboardClose()"
    (opened)="onWhiteboardOpened()"
  ></app-whiteboard>
</app-floating-panel>
